module.exports = __webpack_public_path__ + "images/icons/flags/IE-624f597e.svg";